export default __webpack_public_path__ + "static/media/arrows.4edfebe3.svg";